/* eslint-disable no-unused-vars */
import { Pagination, Space, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { AiOutlineEye } from "react-icons/ai";
import { ImCheckmark } from "react-icons/im";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as Trash } from "../../../../assets/images/svgs/trash.svg";
import SuspendModal from "../../../../components/modals/SuspendModal";
import { getAllCustomers } from "../../../../store/actions/users.action";
import { EmployeeService } from "../../../../utils/services/employees.service";

function Body({
  domainBrand,
  customers = [],
  sizeOfList,
  isLoading,
  setPageSize,
}) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const { Column } = Table;
  const dispatch = useDispatch();
  const history = useHistory();
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const [employeeObject, setEmployeeObject] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUnsuspend = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.verifyCustomer(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Customer verified successfully");
        dispatch(getAllCustomers("UN_VERIFIED", 10, 1));
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const tableData =
    customers &&
    customers?.map((i, index) => {
      return { ...i, key: index + 1 };
    });

  const onChange = (page) => {
    // setPageSize(page);
    dispatch(getAllCustomers("UN_VERIFIED", 20, page));
  };

  return (
    <>
      <SuspendModal
        type={type}
        handleUnsuspend={() => handleUnsuspend(id)}
        show={open}
        handleClose={() => [setOpen(false)]}
        employee={{
          firstName:
            employeeObject?.firstName !== undefined
              ? employeeObject?.firstName
              : "",
          lastName:
            employeeObject?.lastName !== undefined
              ? employeeObject?.lastName
              : "",
        }}
        loading={loading}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary
                  ? dictionary["WO_AWAITING_VERIFICATIO_4608421"]
                  : "Awaiting Verification"}
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  {dictionary
                    ? dictionary[
                        "para_manage_your_customers_here._you_can_view..."
                      ]
                    : "Manage your customers here. You can view the customer details, delete customer details, suspend and reactivate customers here."}
                </li>
              </ol>
            </div>
          </div>

          <div className="row row-sm">
            <div className="col-lg-12 col-md-12">
              <div className="card overflow-hidden">
                <div className="card-body">
                  <div className="table-responsive mt-3">
                    <Table
                      dataSource={tableData}
                      className="w-100 table tbody"
                      loading={isLoading}
                      pagination={false}
                    >
                      <Column
                        title="Signup Date"
                        dataIndex="lastLoginTime"
                        key="1"
                        className=""
                        render={(text) => {
                          return (
                            <span className="text-lowercase whitespace">
                              {moment(text).format("DD/MM/YYYY")}
                            </span>
                          );
                        }}
                        sorter={(a, b) => a.lastLoginTime - b.lastLoginTime}
                      />
                      <Column
                        title="Full Name"
                        dataIndex="fullName"
                        key="2"
                        className=""
                        render={(text, record) => {
                          return (
                            <span className="text-lowercase whitespace">
                              {record.firstName}&nbsp;&nbsp;{record.lastName}
                            </span>
                          );
                        }}
                        sorter={(a, b) => a.firstName - b.firstName}
                      />
                      <Column
                        title="Sender Phone"
                        dataIndex="phone"
                        key="3"
                        className=""
                        sorter={(a, b) => a.phone - b.phone}
                      />
                      <Column
                        title="Email"
                        dataIndex="email"
                        key="4"
                        className=""
                        sorter={(a, b) => a.email - b.email}
                      />
                      <Column
                        title="Status"
                        dataIndex="status"
                        key="5"
                        className=""
                        sorter={(a, b) => a.status - b.status}
                      />
                      <Column
                        title="Action"
                        dataIndex="action"
                        key="6"
                        className=""
                        render={(text, record) => {
                          return (
                            <>
                              <Space size="small">
                                <Tooltip
                                  title={"View"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <AiOutlineEye
                                    color={"#6259CA"}
                                    fontSize={20}
                                    fill={"#6259CA"}
                                    className="cursor-pointer"
                                    // onClick={() =>
                                    //   history.push(
                                    //     `/customer/${record.customerId}`
                                    //   )
                                    // }
                                  />
                                </Tooltip>
                                <Tooltip
                                  title={"Delete"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <Trash
                                    className="cursor-pointer"
                                    style={{ height: "20px" }}
                                  />
                                </Tooltip>
                                <Tooltip
                                  title={"Verify account"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <ImCheckmark
                                    color={"#6259CA"}
                                    fontSize={20}
                                    fill={"#6259CA"}
                                    className="cursor-pointer"
                                    onClick={() => {
                                      setType("VERIFY-EMPLOYEE");
                                      setId(record?.customerId);
                                      setOpen(true);
                                      setEmployeeObject({ ...record });
                                    }}
                                  />
                                </Tooltip>
                              </Space>
                            </>
                          );
                        }}
                      />
                    </Table>
                  </div>
                  <Pagination
                    total={sizeOfList}
                    responsive
                    onChange={(page) => {
                      onChange(page, 10);
                    }}
                    className="float-end pt-1 pb-4"
                    showTotal={(total, range) => {
                      console.log(range, "lo");
                      return `Showing ${range[0]}-${range[1]} of ${total} items`;
                    }}
                    showSizeChanger={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Body;
